/* ════════════════════════════════════════════════════
   OMAR WISEMAN WEALTH — Custom JS
   Paste into: Assets > omar-theme.js
   ════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── Wait for DOM ── */
  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initStats();
    initTabs();
    initCountdown();
    initCarousel();
    initFAQ();
    initReveal();
  });

  /* ════════ STICKY NAV ════════ */
  function initNav() {
    var nav = document.getElementById('owNav');
    if (!nav) return;
    var shown = false;
    window.addEventListener('scroll', function () {
      var scrolled = window.scrollY > 300;
      if (scrolled !== shown) {
        shown = scrolled;
        nav.classList.toggle('visible', shown);
      }
    }, { passive: true });
  }

  /* ════════ STATS COUNTER ════════ */
  function initStats() {
    var nums = document.querySelectorAll('.ow-stats__num[data-target]');
    if (!nums.length) return;

    var observed = false;
    var observer = new IntersectionObserver(function (entries) {
      if (observed) return;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          observed = true;
          nums.forEach(function (el) {
            var target = parseInt(el.getAttribute('data-target'), 10);
            var duration = 1800;
            var start = performance.now();
            function update(now) {
              var elapsed = now - start;
              var progress = Math.min(elapsed / duration, 1);
              var eased = 1 - Math.pow(1 - progress, 3);
              el.textContent = Math.floor(eased * target).toLocaleString();
              if (progress < 1) requestAnimationFrame(update);
              else el.textContent = target.toLocaleString();
            }
            requestAnimationFrame(update);
          });
        }
      });
    }, { threshold: 0.5 });

    var statsEl = document.querySelector('.ow-stats');
    if (statsEl) observer.observe(statsEl);
  }

  /* ════════ TABS ════════ */
  function initTabs() {
    var tabs = document.querySelectorAll('.ow-tab');
    var panels = document.querySelectorAll('.ow-tab-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab');
        tabs.forEach(function (t) { t.classList.remove('ow-tab--active'); });
        panels.forEach(function (p) { p.classList.remove('ow-tab-panel--active'); });
        tab.classList.add('ow-tab--active');
        var panel = document.getElementById('tab-' + target);
        if (panel) panel.classList.add('ow-tab-panel--active');
      });
    });
  }

  /* ════════ COUNTDOWN TIMER ════════ */
  function initCountdown() {
    var storageKey = 'ow_countdown_end';
    var duration = 15 * 60 * 1000; // 15 minutes
    var endTime = parseInt(localStorage.getItem(storageKey), 10);
    if (!endTime || endTime < Date.now()) {
      endTime = Date.now() + duration;
      localStorage.setItem(storageKey, endTime);
    }

    var timers = document.querySelectorAll('.ow-countdown__timer');

    function updateTimers() {
      var remaining = Math.max(0, endTime - Date.now());
      var mins = Math.floor(remaining / 60000);
      var secs = Math.floor((remaining % 60000) / 1000);
      var display = String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
      timers.forEach(function (el) { el.textContent = display; });
      if (remaining <= 0) {
        clearInterval(interval);
        timers.forEach(function (el) { el.textContent = '00:00'; });
      }
    }

    updateTimers();
    var interval = setInterval(updateTimers, 1000);
  }

  /* ════════ CAROUSEL ════════ */
  function initCarousel() {
    var track = document.getElementById('owTrack');
    var prevBtn = document.getElementById('owPrev');
    var nextBtn = document.getElementById('owNext');
    var dots = document.querySelectorAll('.ow-dot');
    if (!track) return;

    var reviews = track.querySelectorAll('.ow-review');
    var totalReal = 3; // 3 real reviews (rest are dupes for loop feel)
    var perView = window.innerWidth >= 768 ? 2 : 1;
    var current = 0;
    var autoplayTimer;

    function getPerView() {
      return window.innerWidth >= 768 ? 2 : 1;
    }

    function goTo(index) {
      perView = getPerView();
      var maxIndex = totalReal - 1;
      current = Math.max(0, Math.min(index, maxIndex));
      var cardWidth = track.parentElement.offsetWidth;
      var offset = current * (cardWidth + 20) / perView;
      // simpler: shift by card widths
      var cards = track.querySelectorAll('.ow-review');
      var cardW = cards[0] ? cards[0].offsetWidth + 20 : cardWidth + 20;
      track.style.transform = 'translateX(-' + (current * cardW) + 'px)';
      dots.forEach(function (d, i) {
        d.classList.toggle('ow-dot--active', i === current);
      });
    }

    function next() { goTo(current + 1 >= totalReal ? 0 : current + 1); }
    function prev() { goTo(current - 1 < 0 ? totalReal - 1 : current - 1); }

    if (nextBtn) nextBtn.addEventListener('click', function () { clearAuto(); next(); resetAuto(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { clearAuto(); prev(); resetAuto(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { clearAuto(); goTo(i); resetAuto(); });
    });

    function clearAuto() { clearInterval(autoplayTimer); }
    function resetAuto() { autoplayTimer = setInterval(next, 4500); }

    // Touch swipe
    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { diff > 0 ? next() : prev(); }
    }, { passive: true });

    window.addEventListener('resize', function () { goTo(current); });
    goTo(0);
    resetAuto();
  }

  /* ════════ FAQ ACCORDION ════════ */
  function initFAQ() {
    var items = document.querySelectorAll('.ow-faq__item');
    items.forEach(function (item) {
      var btn = item.querySelector('.ow-faq__q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        // Close all
        items.forEach(function (i) { i.classList.remove('open'); });
        // Toggle current
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  /* ════════ SCROLL REVEAL ════════ */
  function initReveal() {
    var revealEls = document.querySelectorAll(
      '.ow-arsenal, .ow-checkout, .ow-testimonials, .ow-faq, ' +
      '.ow-product-card, .ow-offer-product, .ow-review, .ow-faq__item'
    );
    revealEls.forEach(function (el) { el.classList.add('ow-reveal'); });

    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(function (el) { observer.observe(el); });
  }

})();